module.exports = __webpack_public_path__ + "img/yihan_img@2x.af87c91c.png";